import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { baseName} from "./utils";

import App from './App';

if ('serviceWorker' in navigator) {
    // Pass the S3 base URL to the service worker via a query param.
    // public/pdftron-sw.js is a static file — webpack doesn't process it,
    // so process.env isn't available there. self.location.search is used instead.
    // Using REACT_APP_PDFTRON_PATH as it contains the S3 URL in the .env config
    const s3base = encodeURIComponent(
        process.env.REACT_APP_PDFTRON_PATH || 'https://pdftron-d.s3.us-east-1.amazonaws.com/lib'
    );
    navigator.serviceWorker.register(`/pdftron-sw.js?s3base=${s3base}`).catch(() => {});
}

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter basename={baseName}>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
